import { render, staticRenderFns } from "./scene4Mobile.vue?vue&type=template&id=10b2422c&scoped=true&"
import script from "./scene4Mobile.vue?vue&type=script&lang=js&"
export * from "./scene4Mobile.vue?vue&type=script&lang=js&"
import style0 from "./scene4Mobile.vue?vue&type=style&index=0&id=10b2422c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b2422c",
  null
  
)

export default component.exports